interface GetPersistedDataProps<T> {
  storageKey: string;
  typeGuard: (data: unknown) => data is T;
}

export const getPersistedData = <T>({
  storageKey,
  typeGuard,
}: GetPersistedDataProps<T>): T | null => {
  const hasKey = Object.keys(window.localStorage).some(k => k === storageKey);

  if (hasKey) {
    try {
      const storageValue = window.localStorage.getItem(storageKey);

      if (storageValue) {
        const data: unknown = JSON.parse(storageValue);

        // Check the data is a valid shape.
        if (data && typeGuard(data)) {
          return data;
        }
      }
    } catch {
      // Swallow
    }
  }

  return null;
};

interface SetPersistedDataProps {
  storageKey: string;
  data: unknown;
}

export const setPersistedData = ({ storageKey, data }: SetPersistedDataProps): void => {
  try {
    window.localStorage.setItem(storageKey, JSON.stringify(data));
  } catch {
    // Swallow
  }
};
